<template>
  <ProseCallout icon="i-lucide-badge-alert" color="important">
    <slot mdc-unwrap="p" />
  </ProseCallout>
</template>
